import Vue from 'vue'
import Header from "./Header"
import Footer from "./Footer"
import Top from "./Top"

Vue.component('Header', Header)
Vue.component('Footer', Footer)
Vue.component('Top', Top)
